import type { NextPage, NextPageContext } from "next"
import type { ErrorProps } from "next/error"
import NextErrorComponent from "next/error"

import Custom404 from "./404"
import Custom500 from "./500"

type CustomErrorProps = Partial<NextPageContext> & ErrorProps

const ErrorPage: NextPage<CustomErrorProps> = ({ statusCode }) => {
  if (statusCode === 404) return <Custom404 />

  return <Custom500 />
}

ErrorPage.getInitialProps = async (pageContext) => {
  const errorInitialProps =
    await NextErrorComponent.getInitialProps(pageContext)
  const { err, res } = pageContext

  const error = res || err

  return { ...errorInitialProps, statusCode: error?.statusCode || 500 }
}

export default ErrorPage
